import { render, staticRenderFns } from "./GeneralPrincipal.vue?vue&type=template&id=763773cb&scoped=true"
import script from "./GeneralPrincipal.vue?vue&type=script&lang=js"
export * from "./GeneralPrincipal.vue?vue&type=script&lang=js"
import style0 from "./GeneralPrincipal.vue?vue&type=style&index=0&id=763773cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763773cb",
  null
  
)

export default component.exports